import { render } from "./EditGroupModal.vue?vue&type=template&id=68705367&scoped=true"
import script from "./EditGroupModal.vue?vue&type=script&lang=js"
export * from "./EditGroupModal.vue?vue&type=script&lang=js"

import "./EditGroupModal.vue?vue&type=style&index=0&id=68705367&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68705367"]])

export default __exports__